export default function React_ES6_Array_map() {
  return (
    <div>
      <h1>React_ES6_Array_map Component</h1>
      <p>This is the React_ES6_Array_map tutorial page.</p>
    </div>
  );
}
